import type { SizeGuideCardData } from "../types"

/** Size guide surface — shows Pearl's recommended kit / quantity for the
 *  customer's project at a glance. Headline = the recommendation, body =
 *  the explanation, then a bulleted product list. Replaces the text-wall
 *  dump Pearl used to send into chat. */
export function SizeGuideCard({ data }: { data: SizeGuideCardData }) {
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 14,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "14px 16px",
          background:
            "linear-gradient(135deg, rgba(109, 195, 247, 0.18), rgba(72, 130, 235, 0.10))",
          borderBottom: "1px solid rgba(109, 195, 247, 0.25)",
        }}
      >
        <div
          style={{
            fontSize: 10.5,
            fontWeight: 600,
            letterSpacing: 0.6,
            textTransform: "uppercase",
            opacity: 0.75,
            marginBottom: 4,
          }}
        >
          {data.projectLabel}
        </div>
        <div
          style={{
            fontSize: 22,
            fontWeight: 700,
            letterSpacing: "-0.01em",
            color: "rgba(255,255,255,0.98)",
            lineHeight: 1.1,
          }}
        >
          {data.recommendedSize}
        </div>
      </div>
      <div style={{ padding: "14px 16px" }}>
        {data.explanation && (
          <p
            style={{
              margin: "0 0 12px",
              fontSize: 13,
              lineHeight: 1.5,
              color: "rgba(255,255,255,0.82)",
            }}
          >
            {data.explanation}
          </p>
        )}
        {data.products.length > 0 && (
          <>
            <div
              style={{
                fontSize: 10.5,
                fontWeight: 600,
                letterSpacing: 0.6,
                textTransform: "uppercase",
                opacity: 0.6,
                marginBottom: 8,
              }}
            >
              What you'll need
            </div>
            <ul
              style={{
                margin: 0,
                padding: 0,
                listStyle: "none",
                display: "flex",
                flexDirection: "column",
                gap: 6,
              }}
            >
              {data.products.map((p, i) => (
                <li
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 10,
                    fontSize: 12.5,
                    color: "rgba(255,255,255,0.88)",
                    lineHeight: 1.4,
                  }}
                >
                  <span
                    aria-hidden="true"
                    style={{
                      flexShrink: 0,
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      background: "rgba(109, 195, 247, 0.85)",
                      marginTop: 7,
                    }}
                  />
                  <span>{p.label}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  )
}
